module.exports = __webpack_public_path__ + "static/media/list-2.d0f4844f.svg";